export default {
  jadlogAgencies: [],
  filters: {
    client: "all",
    limit: 10,
    search: null,
    range: "biweekly",
    page: 1
  },
  clients: [],
  modalOpenFlag: false,
  sidebarOpen: false,
}
